module.exports = __webpack_public_path__ + "static/img/2233logo.9e1b832.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/logo/2233logo.jpg
// module id = ETNL
// module chunks = 0